var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-purchase-orders"},[_c('skeleton-filter-o-p-component'),_c('div',[_c('v-skeleton-loader',{attrs:{"type":"table"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }